export const setContentType = (contentType: string | undefined) =>
  contentType === "video" || contentType === "file" ? "media" : contentType;
